export class AddressModel {
	StreetAddress?: string;
	Suburb?: string;
	City?: string;
	State?: string;
	Country?: string;
	Postcode?: string;

	constructor(data: Partial<AddressModel> = {}) {
		Object.assign(this, data);
	}
}
